import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { IdleService } from './services/idle.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  
  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );

  isLoading = true;


  // rxjsTimer = timer(1000, 1000);

  // timer: number;
  // destroy = new Subject<number>();
  // rxjsTimer: Observable<number>;  // Declare as Observable
  // timer: number;
  // destroy = new Subject<void>();  // Use void for clarity
  // private timerSubscription: Subscription;
  // private idle$: Observable<Event>; 

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService, translate: TranslateService, private idleService:IdleService) {
    if (isPlatformBrowser(this.platformId)) {
      translate.setDefaultLang('en');
      translate.addLangs(['en', 'fr']);
    }

    // You can turn this off after data loads
setTimeout(() => {
  this.isLoading = false;
}, 3000); // or after real data fetch

    // this.rxjsTimer = timer(1000, 1000);

    // this.ngZone.runOutsideAngular(() => {
    //   this.setupIdleDetection(); // Setup event listeners outside Angular zone
    // });
    this.idleService.setupIdleDetection();
  }

  ngOnInit() {
    // this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe(val => {
    //   this.timer = val;
    //   console.log("time ::", this.timer);
      
    //   // Show dialog or alert when timer reaches 10
    //   if (this.timer === 10) {
    //     alert(1);
    //     this.resetTimer(); // Reset the timer
    //   }
    // });
    // this.startTimer();
  }
  // private startTimer(): void {
  //   // Subscribe to the timer
  //   this.timerSubscription = this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe(val => {
  //     this.timer = val;
  //     console.log("time::", this.timer);
  //     if (this.timer === 10) {
  //       // alert(1);
  //       this.resetTimer();  // Reset when timer reaches 10
  //     }
  //   });
  // }

  // Method to reset the timer
  // private resetTimer(): void {
  //   this.timer = 0; 
  //   this.timerSubscription.unsubscribe();  // Unsubscribe from the current timer
  //   this.rxjsTimer = timer(1000, 1000);  // Create a new timer
  //   this.startTimer();  // Restart the subscription
  // }

  // private setupIdleDetection() {
  //   // Merge multiple user activity events into a single observable
  //   this.idle$ = merge(
  //     fromEvent(window, 'mousemove'),
  //     fromEvent(window, 'click'),
  //     fromEvent(window, 'keydown'),
  //     fromEvent(window, 'scroll')
  //   );

  //   // Subscribe to user activity events
  //   this.idle$.subscribe(() => {
  //     // this.userActivity.next(); // Emit user activity
  //     this.destroy.next(); 
  //     this.startTimer();
  //     console.log('User activity detected, resetting timer.');
  //   });
  // }

  // ngOnDestroy() {
  //   this.destroy.next(); 
  //   this.destroy.complete(); 
  //   if (this.timerSubscription) {
  //     this.timerSubscription.unsubscribe();  // Unsubscribe on component destroy
  //   }
  // }

}
